<template>
  <div class="container-fluid py-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div>
        <h2 class="mb-0">Empresa Principal</h2>
        <p class="text-muted mb-0">Datos de la empresa que factura el alquiler del sistema</p>
      </div>
      <button class="btn btn-primary" @click="guardar" :disabled="guardando || !hayCambios">
        <i class="bi" :class="guardando ? 'bi-arrow-clockwise' : 'bi-save'"></i>
        {{ guardando ? 'Guardando...' : 'Guardar cambios' }}
      </button>
    </div>

    <div v-if="error" class="alert alert-danger">{{ error }}</div>
    <div v-if="exito" class="alert alert-success">{{ exito }}</div>

    <div class="card">
      <div class="card-body">
        <div v-if="cargando" class="text-center py-4">
          <div class="spinner-border" role="status"></div>
        </div>
        <form v-else @submit.prevent="guardar">
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label">RUC *</label>
              <input v-model="empresa.ruc" type="text" class="form-control" maxlength="13" placeholder="13 digitos">
            </div>
            <div class="col-md-4">
              <label class="form-label">Razon social *</label>
              <input v-model="empresa.razon_social" type="text" class="form-control">
            </div>
            <div class="col-md-4">
              <label class="form-label">Nombre comercial</label>
              <input v-model="empresa.nombre_comercial" type="text" class="form-control">
            </div>
            <div class="col-md-6">
              <label class="form-label">Direccion matriz</label>
              <input v-model="empresa.direccion" type="text" class="form-control">
            </div>
            <div class="col-md-3">
              <label class="form-label">Telefono</label>
              <input v-model="empresa.telefono" type="text" class="form-control">
            </div>
            <div class="col-md-3">
              <label class="form-label">WhatsApp</label>
              <input v-model="empresa.whatsapp" type="text" class="form-control" placeholder="+593...">
            </div>
            <div class="col-md-4">
              <label class="form-label">Correo</label>
              <input v-model="empresa.correo" type="email" class="form-control">
            </div>
            <div class="col-md-4">
              <label class="form-label">Regimen tributario</label>
              <select v-model="empresa.regimen" class="form-select">
                <option :value="null">Sin especificar</option>
                <option value="general">Regimen General</option>
                <option value="rimpe_emprendedor">RIMPE Emprendedor</option>
                <option value="rimpe_negocio_popular">RIMPE Negocio Popular</option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label">Representante legal</label>
              <input v-model="empresa.representante_legal" type="text" class="form-control">
            </div>
            <div class="col-12">
              <div class="form-check">
                <input v-model="empresa.obligado_contabilidad" class="form-check-input" type="checkbox" id="obligadoContabilidad">
                <label class="form-check-label" for="obligadoContabilidad">
                  Obligado a llevar contabilidad
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="alert alert-info mt-3">
      <i class="bi bi-info-circle me-2"></i>
      Estos datos se usan como emisor en las facturas de suscripcion que el sistema
      genera a las empresas cliente. La firma electronica y el ambiente SRI se
      gestionan en Configuracion &gt; SRI.
    </div>
  </div>
</template>

<script>
import ConfiguracionService from '@/services/configuracion'
import { Toast } from '@/utils/notifications'
import themeMixin from '@/mixins/themeMixin'

export default {
  mixins: [themeMixin],
  name: 'EmpresaPrincipal',
  data() {
    return {
      cargando: true,
      guardando: false,
      error: null,
      exito: null,
      empresa: {},
      original: {}
    }
  },
  computed: {
    hayCambios() {
      return JSON.stringify(this.empresa) !== JSON.stringify(this.original)
    }
  },
  async mounted() {
    await this.cargar()
  },
  methods: {
    async cargar() {
      this.cargando = true
      this.error = null
      try {
        const res = await ConfiguracionService.getEmpresaPrincipal()
        if (res.exito) {
          this.empresa = res.datos || {}
          this.original = JSON.parse(JSON.stringify(this.empresa))
        } else {
          this.error = res.error || 'Error al cargar los datos'
        }
      } catch (e) {
        this.error = 'Error al cargar: ' + (e.response?.data?.error || e.message)
      } finally {
        this.cargando = false
      }
    },
    async guardar() {
      if (this.empresa.ruc && this.empresa.ruc.length !== 13) {
        Toast.error('El RUC debe tener 13 digitos')
        return
      }
      if (!this.empresa.razon_social || !this.empresa.razon_social.trim()) {
        Toast.error('La razon social es obligatoria')
        return
      }
      this.guardando = true
      this.error = null
      this.exito = null
      try {
        const res = await ConfiguracionService.updateEmpresaPrincipal(this.empresa)
        if (res.exito) {
          this.original = JSON.parse(JSON.stringify(this.empresa))
          this.exito = 'Datos guardados correctamente'
          Toast.success('Empresa principal actualizada')
        } else {
          this.error = res.error || 'Error al guardar'
          Toast.error(this.error)
        }
      } catch (e) {
        this.error = e.response?.data?.error || 'Error al guardar'
        Toast.error(this.error)
      } finally {
        this.guardando = false
      }
    }
  }
}
</script>

<style scoped>
.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
</style>
